<template>
  <std-form-page
      ref="page"
      :id="project_id"
      :item="item"
      identity="project_id"

      url="/projects"
      resource="project"

      icon="bi-gear"
      title-new="Создать новый проект"
      :title="'Проект ' + project_id"

      :before-delete="beforeDelete"
  >
    <template v-slot:default>

      <f-input v-model="item.project_id" label="ID проекта" w="12" :disabled="!!project_id"/>
      <f-input v-model="item.description" label="Описание" w="12"/>
      <f-input v-model="item.nlu" type="select" label="NLU" w="6">
        <option :value="null">Нет</option>
        <option v-for="i in inventory.filter(i=>i.kind=='nlu')" :key="i" :value="i.name">{{ i.name }} - {{ i.description }}</option>
      </f-input>
      <f-input v-model="item.http_ep_config" type="select" label="Конфигурация HTTP ендпоинта" w="6">
        <option :value="null">Нет</option>
        <option v-for="i in inventory.filter(i=>i.kind=='http_ep_config')" :key="i" :value="i.name">{{ i.name }} - {{ i.description }}</option>
      </f-input>
      <f-input v-model="item.tgbot" type="select" label="Телеграм бот" w="6">
        <option :value="null">Нет</option>
        <option v-for="i in inventory.filter(i=>i.kind=='tgbot')" :key="i" :value="i.name">{{ i.name }} - {{ i.description }}</option>
      </f-input>
      <f-input v-model="item.maxbot" type="select" label="Макс бот" w="6">
        <option :value="null">Нет</option>
        <option v-for="i in inventory.filter(i=>i.kind=='maxbot')" :key="i" :value="i.name">{{ i.name }} - {{ i.description }}</option>
      </f-input>

      <item-picker
          title="Пользователи"
          :items="item.users"
          button="Добавить пользователей в проект"
          :format="[
          ['user','Пользователь', i=>i.name || i.login],
          ['active','Активный', (i)=>i.active?'Да':'Нет'],
        ]"
          :format-item="i=>users[i] || i"
          source="/users"
          @item-add="item.users.indexOf($event.login)==-1?item.users.push($event.login):0"
          @item-delete="item.users.indexOf($event)!=-1?item.users.splice(item.users.indexOf($event),1):0"
      />
    </template>
    <template v-slot:actions="form">
      <button
          v-if="!form.edit"
          type="button" class="btn btn-outline-primary"
          @click="$router.push({name: 'myproject', params:{project_id: project_id}})"
      >
        К установкам
      </button>

    </template>

  </std-form-page>
</template>

<script>
import FInput from "@/components/FInput";
import StdFormPage from "@/components/StdFormPage";
import ItemPicker from "@/components/ItemPicker";
import {http} from "@/misc/http";

export default {
  components: {ItemPicker, StdFormPage, FInput},
  props: ["project_id"],
  data() {
    return {
      item: {
        project_id: "",
        description: "",
        nlu: null,
        tgbot: null,
        maxbot: null,
        users: [],
      },
      inventory: [],
      users: {},
    }
  },

  mounted() {
    this.$refs.page.wrap(async () => {
      this.inventory = await http.get("/inventory");
      this.users = (await http.get("/profile/all")).reduce(
          (acc, user) => ({...acc, ...{[user.login]: user.name}}),
          {}
      );
    });
  },

  methods: {
    beforeDelete() {
      return confirm("Это удалит проект, все связанные с ним сценарии, записи об установках и остановит трафик. Вы точно уверены?");
    },
  },


}
</script>

